import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { sanitizeTxListSearch } from "@/features/transactions/tx-search";
import { appRoute } from "./route";

const TxListView = lazy(async () => {
  const m = await import("@/features/transactions/components/tx-list-view");
  return { default: m.TxListView };
});

function TransactionsPage() {
  return (
    <Suspense fallback={null}>
      <TxListView />
    </Suspense>
  );
}

export const transactionsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/transactions",
  validateSearch: sanitizeTxListSearch,
  component: TransactionsPage,
});
